const useSolicitudEncargoStore = defineStore("solicitud-encargo", () => {
  // state
  const solicitud_encargo = ref({
    id: null,
    nombre: null,
    email: null,
    telefono: null,
    descripcion: "",
    estatus: 1, // 1: Pendiente, 2: atendida, 3: Rechazada
    solicitante_id: null,
    solicitante: null,
    autor_id: null,
    autor: null,
    oferta_id: null,
    oferta: null,
  });

  const solicitudes = ref([]);

  const optionsEstatus = ref([
    { label: "Pendiente", value: 1 },
    { label: "Atendida", value: 2 },
    { label: "Rechazada", value: 3 },
  ]);

  // getters
  const draft = computed(() => {
    return clone(solicitud_encargo.value);
  });

  const getEstatus = (estatus) => {
    return optionsEstatus.value.find((option) => option.value == estatus);
  };

  // mutations

  const clear = () => {
    solicitud_encargo.value = {
      id: null,
      nombre: null,
      email: null,
      telefono: null,
      descripcion: "",
      estatus: 1, // 1: Pendiente, 2: atendida, 3: Rechazada
      solicitante_id: null,
      solicitante: null,
      autor_id: null,
      autor: null,
      oferta_id: null,
      oferta: null,
    };
  };

  const setSolicitud = (solicitude) => {
    solicitud_encargo.value = solicitude;
  };

  const capturar = (id_solicitud) => {
    solicitud_encargo.value = solicitudes.value.find(
      (solicitude) => solicitude.id == id_solicitud
    );
  };

  const setSolicitudes = (data) => {
    if (!data.length) return;
    solicitudes.value = data;
  };

  const update = (data) => {
    let i = solicitudes.value.findIndex((val) => val.id == data.id);
    if (i != -1) {
      solicitudes.value[i] = data;
    }

    if (solicitud_encargo.value.id == data.id) solicitud_encargo.value = data;
  };

  const put = (solicitud_id) => {
    let i = solicitudes.value.findIndex((val) => val.id == solicitud_id);
    if (i != -1) {
      solicitudes.value.splice(i, 1);
    }
  };

  // actions

  const fetch = (solicitud_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/solicitud-encargos/${solicitud_id}/fetch-data`)
        .then(({ data }) => {
          setSolicitud(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/solicitud-encargos/fetch-data`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const eliminar = (solicitud_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/solicitud-encargos/${solicitud_id}`)
        .then(({ data }) => {
          put(solicitud_id);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = async (datos) => {
    try {
      const { data } = datos.id
        ? await axios.put(`/api/solicitud-encargos/${data.id}`, datos)
        : await axios.post(`/api/solicitud-encargos`, datos);

      if (data.result) {
        setSolicitud(data.solicitud);
      }

      return data;
    } catch (error) {
      throw error;
    }
  };

  const asignarOferta = async (solicitud_id, oferta_id) => {
    try {
      const { data } = await axios.get(
        `/api/solicitud-encargos/${solicitud_id}/asignar-oferta/${oferta_id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getSolicitudesPendientesCount = async () => {
    try {
      const { data } = await axios.get(
        `/api/solicitud-encargos/pendientes/count`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const fetchToPublic = (solicitud_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/solicitud-encargos/${solicitud_id}/fetch-data-public`)
        .then(({ data }) => {
          if (data.result) {
            setSolicitud(data.solicitud);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const rechazarOferta = async (oferta_id) => {
    try {
      const { data } = await axios.get(
        `/api/solicitud-encargos/rechazar-oferta/${oferta_id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    solicitud_encargo,
    solicitudes,
    draft,
    optionsEstatus,
    clear,
    setSolicitud,
    capturar,
    setSolicitudes,
    update,
    fetch,
    fetchData,
    put,
    eliminar,
    guardar,
    getEstatus,
    asignarOferta,
    getSolicitudesPendientesCount,
    fetchToPublic,
    rechazarOferta,
  };
});

export default useSolicitudEncargoStore;
